import LogList from './LogList';
import HeaderMenu from '../menu/HeaderMenu'
import FooterMenu from '../menu/FooterMenu'

const Log = ({...props }) => {
    return (
        <div>
            <HeaderMenu />
            <LogList />
            <FooterMenu />
        </div>
    );
};

export default Log;